import Api from 'configs';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import UpdateShop from 'types/shop';

export const useCreateShop = () => {
  return useMutation({
    mutationKey: ['createShop'],
    mutationFn: async (body: UpdateShop) => {
      const {data} = await Api.post(`/admin/shops`, body);
      return data;
    },
  });
};

export const useUpdateShop = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['updateShop'],
    mutationFn: async (variables: {
      body: UpdateShop;
      idShop: string;
      idQuery: string;
    }) => {
      const {idShop, body, idQuery} = variables;
      const {data} = await Api.put(`/admin/shops/${idShop}`, body);
      queryClient.invalidateQueries(['useGetShopById', idQuery]);
      return data;
    },
  });
};

export const useUpdateShopActive = () => {
  return useMutation({
    mutationKey: ['useUpdateShopActive'],
    mutationFn: async (idShop: string) => {
      const {data} = await Api.put(`/admin/shops/active/${idShop}`);
      return data;
    },
  });
};

export const useToggleShopBlock = () => {
  return useMutation({
    mutationKey: ['useToggleShopBlock'],
    mutationFn: async (variables: {shopId: string; reason?: string} | string) => {
      const shopId = typeof variables === 'string' ? variables : variables.shopId;
      const reason = typeof variables === 'object' ? variables.reason : undefined;
      const {data} = await Api.put(`/admin/shops/${shopId}/toggle-block`, {reason});
      return data;
    },
  });
};

export const useVerifyShop = () => {
  return useMutation({
    mutationKey: ['useVerifyShop'],
    mutationFn: async (shopId: string) => {
      const {data} = await Api.put(`/admin/shops/${shopId}/verify`);
      return data;
    },
  });
};
